import { Breadcrumbs } from "AbstractElements"
import PopupNotificationContain from "Component/Learning/PopupNotification/PopupNotificationContain"

const PopupNotificationList = () => {
  return (
    <>
      <Breadcrumbs title="Popup Notification" />
      <PopupNotificationContain />
    </>
  )
}

export default PopupNotificationList